import React from 'react';

const SvgIs = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="IS_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="IS_svg__b" fill="#fff">
        <use xlinkHref="#IS_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#IS_svg__a" />
      <path fill="#0E4CB5" mask="url(#IS_svg__b)" d="M0 0h28v20H0z" />
      <path
        fill="#FFF"
        mask="url(#IS_svg__b)"
        d="M0 12h8v8h4v-8h16V8H12V0H8v8H0z"
      />
      <path
        fill="#EB363A"
        mask="url(#IS_svg__b)"
        d="M0 10.667h9.333V20h1.334v-9.333H28V9.333H10.667V0H9.333v9.333H0z"
      />
    </g>
  </svg>
);

export default SvgIs;
